import { render, staticRenderFns } from "./online.vue?vue&type=template&id=04d8c011&scoped=true"
import script from "./online.vue?vue&type=script&lang=ts"
export * from "./online.vue?vue&type=script&lang=ts"
import style0 from "./online.vue?vue&type=style&index=0&id=04d8c011&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04d8c011",
  null
  
)

export default component.exports